import React from 'react';
import { SwitchOffIcon, SwitchOnIcon } from 'assets/icons';
import { Container } from './styles';

const Slider = ({
  checked,
  onActivate,
  onDeactivate,
}) => {

  const handleToggle = () => {
    if(checked) {
      onDeactivate();
    } else {
      onActivate();
    }
  }

  return (
    <Container>
      <div
        className={`switch ${checked? 'active': ''}`}
        onClick={handleToggle}
      >
        <div className={`switchSlider ${checked? 'active': ''}`}>
          {checked? <SwitchOnIcon />: <SwitchOffIcon />}
        </div>
      </div>
      <div className={`switchText ${checked? 'active': ''}`}>
        {checked? 'ON': 'OFF'}
      </div>
    </Container>
  );
}

export default Slider;
